var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBeerBottle = function SvgIconBeerBottle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.207.793a1 1 0 0 0-1.476 1.346l-4.9 3.675-3.527.705a1 1 0 0 0-.511.274l-7.94 7.94-.006.006a2.51 2.51 0 0 0 0 3.522l.005.006 3.881 3.88.006.006a2.51 2.51 0 0 0 3.522 0l.005-.005 1.556-1.556.01-.01.01-.01 4.855-4.855.01-.01.01-.01 1.49-1.49a1 1 0 0 0 .273-.51l.706-3.528 3.675-4.9a1 1 0 0 0 1.346-1.476zM10.125 18.46 13.585 15 9 10.414l-3.46 3.46zm-6-3.172-.855.855a.51.51 0 0 0 0 .712l.002.002 3.87 3.87.002.002a.51.51 0 0 0 .711 0l.002-.002.854-.853zm11.454-2.282-.58.579L10.415 9l.579-.579 3.453-.69a1 1 0 0 0 .404-.181l5.306-3.98.274.274-3.98 5.306a1 1 0 0 0-.18.404z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBeerBottle;